'use client'

import { ITransactionDetailInstruction } from 'interfaces/tx.interface'
import { useCallback, useState } from 'react'
import { instructionMapper, type CustomInstructionProps } from '../function/instructionMapper'
import { BBAAccount, BBABalance } from 'components/blockchain'
import Moment from 'react-moment'
import { FaAngleDown, FaAngleUp } from 'react-icons/fa6'
import { capitalCase } from 'text-case'

function InstructionDetailItem({
	instructionItem,
	index
}: {
	instructionItem: ITransactionDetailInstruction
	index: number
}) {
	const rowData: CustomInstructionProps[] = [
		{
			label: 'Program',
			content: instructionItem.programId,
			type: 'link'
		},
		...instructionMapper(instructionItem)
	]

	const renderRowValue = useCallback((row: CustomInstructionProps) => {
		switch (row.type) {
			case 'link':
				return <BBAAccount link address={row.content} />
			case 'balance':
				return <BBABalance daltons={Number(row.content)} />
			case 'date':
				return <Moment className="!text-small" date={Number(row.content) * 1000} fromNow />
			default:
				return <p>{row.content}</p>
		}
	}, [])

	return (
		<div className="flex flex-col space-y-[18px]">
			<h2 className="text-base">
				#{index + 1} {capitalCase(instructionItem.parsed.type)}
			</h2>
			{rowData.map((row, index) => (
				<div key={index} className="flex w-full space-x-3">
					<h4 className="text-small w-full md:max-w-[300px] text-gray-700 dark:text-gray-300">{row.label}:</h4>
					{renderRowValue(row)}
				</div>
			))}
		</div>
	)
}

export default function InstructionDetailCard({
	instructionData
}: {
	instructionData: ITransactionDetailInstruction[]
}) {
	const [instructionVisible, setInstructionVisible] = useState<boolean>(true)
	return (
		<div className="box mb-3 overflow-hidden bg-white px-2.5 py-5 dark:bg-darkPrimary md:px-5">
			<div className="flex justify-between border-b-[1px] border-gray-100 py-4 dark:border-lightGrey">
				<h2 className="text-large">Instruction</h2>
				<button
					type="button"
					className="text-small flex items-center text-green-900"
					onClick={() => setInstructionVisible(!instructionVisible)}
				>
					{`${!instructionVisible ? 'View' : 'Hide'} More Details`}
					<span className="ml-[1px] text-xs">{!instructionVisible ? <FaAngleDown /> : <FaAngleUp />}</span>
				</button>
			</div>
			<div className={`mt-2 w-full space-y-8 flex flex-col ${instructionVisible ? '' : 'hidden'}`}>
				{instructionData.map((instruction, index) => (
					<InstructionDetailItem key={index} instructionItem={instruction} index={index} />
				))}
			</div>
		</div>
	)
}
